<template>
	<div v-if="uploads.length > 0 ? true: false">
		<div style="margin: 5px; padding: 5px;" v-for="(upload, idx) in uploads" class="email" :key="upload._id">
			<b style='color:purple;font-size:16px'>File: {{ upload.originalFileName }}</b><br />
			<b>On:</b> {{ new Date(upload.when).toLocaleDateString() }} {{ new Date(upload.when).toLocaleTimeString() }},
			<b>Total:</b> {{ upload.successCount }},
			<b>New:</b> {{ upload.newMemberCount }},
			<b>Rejected:</b> {{ upload.rejectCount }},
			<b>Updated:</b> {{ upload.updateCount }}<br />
			<button @click="toggleChanges(idx)">
				{{ isChangesVisible(idx) ? 'Close Changes' : 'Show Changes' }}
			</button>
			<transition name="expand">
				<div v-if="upload.changeLog && isChangesVisible(idx)" class="changes-container">
					<!-- Pagination Info -->
					<div v-if="getTotalChanges(idx) > 0" class="pagination-info">
					<span class="pagination-summary">
						Showing {{ getDisplayStart(idx) }}-{{ getDisplayEnd(idx) }} of {{ getTotalChanges(idx) }} changes
					</span>
					<div class="items-per-page-selector" v-if="showPagination(idx)">
						<label>Items per page:</label>
						<select v-model="paginationSettings[idx].itemsPerPage" @change="handleItemsPerPageChange(idx)">
							<option v-for="option in paginationOptions" :key="option" :value="option">
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<!-- Paginated Changes List -->
				<div v-for="(mem, mi) in getPaginatedChanges(idx)" :key="`member:${mi}:${mem._id}`" class="member-item">
					<div v-if="mem.changes[0].field == 'All'" class="member-header">
						<a :href="`/members/${mem._id}`" target="_blank" style="color:green;font-weight:600">
							{{ mem.externalID }} {{ mem.first }} {{ mem.last }}
						</a>
						<span class="new-member-badge">[New Member]</span>
					</div>
					<div v-if="mem.changes[0].field != 'All'">
						<!-- Member Header with Toggle -->
						<div class="member-header-with-toggle">
							<button
								class="toggle-details-btn"
								@click="toggleMemberDetails(idx, mi)"
								:title="isMemberExpanded(idx, mi) ? 'Hide details' : 'Show details'"
							>
								<span v-if="isMemberExpanded(idx, mi)">▲</span>
								<span v-else>▼</span>
							</button>
							<a :href="`/members/${mem._id}`" target="_blank" class="member-name-link">
								{{ mem.externalID }} {{ mem.first }} {{ mem.last }}
							</a>
							<span class="changes-count">{{ mem.changes.length }} change{{ mem.changes.length !== 1 ? 's' : '' }}</span>
						</div>

						<!-- Collapsible Changes Details -->
						<div v-if="isMemberExpanded(idx, mi)" class="member-changes-details">
							<div v-for="(chg, ci) in mem.changes" :key="`member:${mi},change:${ci}`" class="change-item">
								-- <b style="color:darkblue">{{ chg.field }}:</b>
								<i style="text-decoration: line-through;color: gray">{{ chg.before || chg.before == false ? chg.before : "NULL" }}</i>
								<span style="color:green"> → {{ chg.after }}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Pagination Controls -->
				<div v-if="showPagination(idx)" class="pagination-controls">
					<paginate
						v-model="paginationSettings[idx].currentPage"
						:page-count="getTotalPages(idx)"
						:page-range="3"
						:margin-pages="2"
						:click-handler="(pageNum) => handlePageChange(idx, pageNum)"
						:prev-text="'Prev'"
						:next-text="'Next'"
						:container-class="'pagination'"
						:page-class="'page-item'"
					/>
				</div>
				</div>
			</transition>
		</div>
	</div>
	<div v-else >
		<div style="margin: 10px 0px">
			<span>No member files have been uploaded yet..</span>
		</div>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import Paginate from "vuejs-paginate";
import Vue from "vue";
import paginatedUploadsMixin from "../mixins/paginatedUploadsMixin";

Vue.component("paginate", Paginate);

export default {
	name: "RecentUploads",
	components: {
		Paginate
	},
	mixins: [paginatedUploadsMixin],
	props: ["community_id"],
	data() {
		return {
			api: new API(),
			uploads: [],
			logKey: "changeLog",
			expandedMembers: {},
			visibleChanges: {}
		};
	},
	watch: {
		"community_id": "loadData"
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData: function () {
			if (this.community_id) {
				this.api.get(`communities/${this.community_id}/recent-uploads`).then(uploads => {
					this.uploads = uploads.data;
					this.initializePaginationSettings();
				});
			}
		},
		getFullDetails: function (idx) {
			this.api.get(`communities/${this.community_id}/recent-uploads/${this.uploads[idx]._id}`).then(upload => {
				this.uploads[idx] = upload.data;
				this.$forceUpdate();
				this.initializePaginationForUpload(idx);
			});
		},

		toggleChanges(idx) {
			if (!this.uploads[idx].changeLog) {
				// Si no hay datos cargados, cargarlos primero y mostrarlos
				this.getFullDetails(idx);
				this.$set(this.visibleChanges, idx, true);
			} else {
				// Toggle la visibilidad
				this.$set(this.visibleChanges, idx, !this.visibleChanges[idx]);
			}
		},

		isChangesVisible(idx) {
			return this.visibleChanges[idx] || false;
		},

		toggleMemberDetails(uploadIdx, memberIdx) {
			if (!this.expandedMembers[uploadIdx]) {
				this.$set(this.expandedMembers, uploadIdx, {});
			}
			const currentState = this.expandedMembers[uploadIdx][memberIdx] || false;
			this.$set(this.expandedMembers[uploadIdx], memberIdx, !currentState);
		},

		isMemberExpanded(uploadIdx, memberIdx) {
			if (!this.expandedMembers[uploadIdx]) return false;
			return this.expandedMembers[uploadIdx][memberIdx] || false;
		}
	}
};
</script>

<style scoped>
  @import "../styles/pagination.css";
</style>



// WEBPACK FOOTER //
// src/components/RecentUploads.vue